export function CampaignWizardStepper({
  steps,
  current,
}: {
  steps: string[];
  current: number;
}) {
  return (
    <ol className='mb-4 flex flex-wrap gap-2' aria-label='Pasos de la campaña'>
      {steps.map((label, index) => {
        const step = index + 1;
        const done = step < current;
        const active = step === current;
        return (
          <li
            key={label}
            aria-current={active ? 'step' : undefined}
            className={`flex items-center gap-2 rounded-lg border px-3 py-2 text-sm ${
              active ? 'border-primary font-medium' : 'text-muted-foreground'
            }`}
          >
            <span
              className={`flex h-6 w-6 items-center justify-center rounded-full text-xs ${
                done ? 'bg-primary text-primary-foreground' : active ? 'border border-primary' : 'border'
              }`}
            >
              {done ? '✓' : step}
            </span>
            <span className='hidden sm:inline'>{label}</span>
          </li>
        );
      })}
    </ol>
  );
}
